import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpEvent,
    HttpHandler,
    HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const startTime = Date.now();
        let status: string;

        return next.handle(req).pipe(
            tap({
                next: (event) => (status = 'succeeded'),
                error: (error) => (status = 'failed'),
            }),
            finalize(() => {
                const duration = Date.now() - startTime;
                const message = `[API] ${req.method} "${req.urlWithParams}" ${status} in ${duration}ms`;
                console.log(message);
            })
        );
    }
}
